import {
  PostIntegranteResolucion,
  GetIntegranteCargosByFolio,
  GetIntegrantesEliminados,
  GetAltasEnMembresiasExistentes,
  PutReasignarCargoIntegrante
} from "../../../reducers/comisionMembresia";
import * as actions from "../../../actions/comisionMembresia";
import { Preview } from "../../../../types/IAction";
import MembresiaIntegranteResolucion from "../../../../types/MembresiaIntegranteResolucion";

export interface IntegranteResolucionDispatcher {
  postResolucionIntegrante: (
    resolucion: MembresiaIntegranteResolucion
  ) => Promise<Preview<PostIntegranteResolucion>>;
  getCargosByFolioFactura: (
    folioFactura: string
  ) => Promise<Preview<GetIntegranteCargosByFolio>>;
  getIntegrantesEliminados: (
    periodo: string
  ) => Promise<Preview<GetIntegrantesEliminados>>;
  getAltasEnMembresiasExistentes: (
    periodo: string
  ) => Promise<Preview<GetAltasEnMembresiasExistentes>>;
  putReasignarCargoIntegrante: (
    idCotizacionItem: number,
    idMembresiaSocioPersona: number
  ) => Promise<Preview<PutReasignarCargoIntegrante>>;
  clearIntegranteResolucion: () => Promise<Preview<void>>;
}

export const integranteResolucionDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => IntegranteResolucionDispatcher = dispatch => ({
  postResolucionIntegrante: (resolucion: MembresiaIntegranteResolucion) => {
    return dispatch(actions.postResolucionIntegrante(resolucion));
  },
  getCargosByFolioFactura: (folioFactura: string) => {
    return dispatch(actions.getCargosByFolioFactura(folioFactura));
  },
  getIntegrantesEliminados: (periodo: string) => {
    return dispatch(actions.getIntegrantesEliminados(periodo));
  },
  getAltasEnMembresiasExistentes: (periodo: string) => {
    return dispatch(actions.getAltasEnMembresiasExistentes(periodo));
  },
  putReasignarCargoIntegrante: (
    idCotizacionItem: number,
    idMembresiaSocioPersona: number
  ) => {
    return dispatch(
      actions.putReasignarCargoIntegrante(
        idCotizacionItem,
        idMembresiaSocioPersona
      )
    );
  },
  clearIntegranteResolucion: () => {
    return dispatch(actions.clearIntegranteResolucion());
  }
});
